import React,{useEffect, useState} from 'react'
import CustomDialog from '../../../components/CustomDialog';
import { Grid, TextField } from '@mui/material';
import { FaSave } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

const GoalResultEditModal = (props) => {
    const { open, setOpen, handleSave, isMobile, selectedInfo } = props;
    const [isPostPoned, setIsPostponed] = useState(false);
    const [isOverLimit,setIsOverLimit] = useState(false);
    const [homeResult, setHomeResult] = useState(0);
    const [awayResult, setAwayResult] = useState(0);
    const [isDisabled,setIsDisabled] = useState(false);

    useEffect(() => {
      console.log("selectedInfo",selectedInfo)
      setHomeResult(selectedInfo?.homeGoal || 0);
      setAwayResult(selectedInfo?.awayGoal || 0);
      setIsDisabled(false);
      setIsOverLimit(false);
      setIsPostponed(false);
    },[selectedInfo])

    const handleClose = () => {
        setOpen(false);
        setAwayResult(selectedInfo.homeGoal);
        setHomeResult(selectedInfo.awayGoal);
        setIsOverLimit(false);
        setIsPostponed(false);
        setIsDisabled(false);
    }

    const handleChange = (event, type) => {
        if (type === "pp") {
            setIsPostponed(event.target.checked);
            setAwayResult(event.target.checked ? "-2" : selectedInfo.homeGoal);
            setHomeResult(event.target.checked ? "-2" : selectedInfo.awayGoal);
            setIsDisabled(event.target.checked ? true : false);
        }
        if (type === "over") setIsOverLimit(event.target.checked);
    };

    return (
        <CustomDialog open={open} width={500} isMobile={isMobile}>
            <Grid container spacing={1}>
                <Grid item xs={isMobile ? 12 : 6}>
                    <TextField
                        size="small"
                        label="Home Result"
                        type="number"
                        value={homeResult}
                        style={{ marginBottom: 10, fontSize: '1rem' }}
                        onChange={(e) => setHomeResult(e.target.value)}
                        disabled = {isDisabled}
                    />
                    <TextField
                        size="small"
                         type="number"
                        label="Away Result"
                        value={awayResult}
                        style={{ fontSize: '1rem' }}
                        onChange={(e) => setAwayResult(e.target.value)}
                        disabled={isDisabled}
                    />
                </Grid>
                <Grid item xs={isMobile ? 12 : 6}>
                    <FormGroup>
                        <FormControlLabel
                            control={<Checkbox checked={isPostPoned} onChange={(e) => handleChange(e,"pp")} />}
                            label="PostPoned"

                        />
                        <FormControlLabel
                            control={<Checkbox checked={isOverLimit} onChange={(e) => handleChange(e,"over")} />}
                            label="Limit Over Time"
                        />
                    </FormGroup>
                </Grid>
            </Grid>
            <div className='flex justify-center items-center gap-4 mt-3 text-[0.875rem]'>
                <div className='flex items-center gap-2'>
                    <button
                        onClick={() => handleSave(isPostPoned,isOverLimit,homeResult,awayResult,selectedInfo.eventId)}
                        className='flex items-center px-3 py-1 border rounded bg-background text-customBackColor'
                    >
                        <FaSave className='mr-1' />Save
                    </button>
                </div>
                <div className='flex items-center gap-2'>
                    <button
                        className='flex items-center px-3 py-1 border rounded bg-customTitleColor'
                        onClick={() => handleClose()}
                    ><ImCross className='mr-1' />Cancel
                    </button>
                </div>
            </div>
        </CustomDialog>
    )
}

export default GoalResultEditModal